import React, { useRef, useEffect, useState, Fragment } from "react";
import ReactSignatureCanvas from "react-signature-canvas";
import { FormattedMessage as FM } from "react-intl";

import { PlusCircleIcon } from "components/Icons";
import Dialog from "componentsv2/modal/Dialog";
import Button from "componentsv2/button/Button";
import { cn } from "tools/ui";

function SignatureCell({ onSave, label, model, name, value, className }) {
  const [signatureImage, setSignatureImage] = useState(value ?? "");
  const [openModal, setOpenModal] = useState({ value: false });
  const signatureCanvasRef = useRef(null);

  useEffect(() => {
    if (value) {
      const isBase64Full = value.startsWith("data:image");
      const fixedValue = isBase64Full
        ? value
        : `data:image/png;base64,${value}`;
      setSignatureImage(fixedValue);
    } else {
      setSignatureImage("");
    }
  }, [value]);

  const clearSignature = () => {
    signatureCanvasRef.current?.clear();
    setOpenModal({ value: false });
  };

  const saveSignature = () => {
    if (signatureCanvasRef.current && !signatureCanvasRef.current.isEmpty()) {
      const dataUrl = signatureCanvasRef.current.toDataURL();
      const base64Data = dataUrl.replace(/^data:image\/\w+;base64,/, "");

      setSignatureImage(dataUrl);
      onSave?.({ name, image: base64Data });
      setOpenModal({ value: false });
    } else {
      console.error("Por favor firma antes de guardar.");
    }
  };

  function ButtonsActions() {
    return (
      <div className="flex space-x-[19px] w-full max-w-[327px] justify-center mx-auto pointer-events-auto">
        <Button
          color=""
          content="Cancelar"
          size="w-full"
          onClick={clearSignature}
        />
        <Button
          color="amber"
          content="Aceptar y Firmar"
          size="w-full"
          onClick={saveSignature}
        />
      </div>
    );
  }

  return (
    <Fragment>
      <div className={cn(`w-fit flex space-x-3`, className)}>
        <div>
          <button onClick={() => setOpenModal({ value: true })}>
            <PlusCircleIcon className="w-10 h-10 cursor-pointer fill-current text-yellow-500 shadow-xl rounded-full hover:text-gray-800" />
          </button>
        </div>

        <div className="space-y-[12px] w-full">
          <div className="min-h-[100px] w-[400px] border-b border-[#1f2837] border-dashed flex items-center justify-center">
            {signatureImage ? (
              <img
                src={signatureImage}
                alt="Firma"
                className="object-contain max-h-[100px]"
              />
            ) : (
              <span className="text-gray-400 text-sm">
                <FM id="staff.supply.no_signature" />
              </span>
            )}
          </div>

          <div className="font-bold text-[18px] text-center text-[#1f2837]">
            <span>{label && <FM id={label} />}</span>
          </div>
        </div>
      </div>

      <Dialog
        openModal={openModal}
        handleClose={() => setOpenModal({ value: false })}
        style="!w-[500px] !h-fit"
        hiddenHeader={true}
        title={label}
      >
        <div className="mt-4 flex flex-col h-full w-full space-y-5">
          <ReactSignatureCanvas
            ref={signatureCanvasRef}
            penColor="black"
            canvasProps={{
              width: 400,
              height: 200,
              className: "signature-canvas bg-gray-200 rounded-md",
            }}
          />

          <ButtonsActions />
        </div>
      </Dialog>
    </Fragment>
  );
}

export default SignatureCell;
